import { usePaymentMethod } from '@payments-checkout/shared/providers';
import { Box } from '@stone-payments/jade';
import { CustomAlert } from './alert';

export const PaymentFailedAlert = () => {
  const {
    showFailedPaymentAlert,
    setShowFailedPaymentAlert,
    failedPaymentMessage,
  } = usePaymentMethod();
  
  if (!showFailedPaymentAlert || !failedPaymentMessage) return null;

  return (
    <Box className="max-w-[464px]">
      <CustomAlert
        description={failedPaymentMessage}
        showIcon
        variant="warning"
        onDismiss={() => setShowFailedPaymentAlert(false)}
      />
    </Box>
  );
};
